

import React from "react";
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,

} from "reactstrap";


export const ImageViewModel = ({
  filepath = "",
  ext = "png",
  isOpen = false,
  toggle = () => {},
}) => {
  ext = filepath ? filepath.split('.').at(-1) : ext
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="requs-pops">
      <ModalHeader>
        <Button onClick={toggle}>
          <i className="fa fa-times" aria-hidden="true"></i>
        </Button>
      </ModalHeader>
      <ModalBody>
        <div className="img-views">
          {filepath && String(ext) === String("pdf") ? (
            <embed src={filepath} width="100%" height="100%" />
          ) : (
            <div style={{ width: "100%", height: "400px" }}>
              <img
                style={{ float: "left", width: "100%", height: "100%" }}
                alt="imgviewer"
                src={filepath}
              />
            </div>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};